import { render, staticRenderFns } from "./trafficPoolDetail.vue?vue&type=template&id=2e4a9d13&"
import script from "./trafficPoolDetail.vue?vue&type=script&lang=js&"
export * from "./trafficPoolDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports